import { render, staticRenderFns } from "./DataManagement.vue?vue&type=template&id=2ceac6b2&scoped=true&"
import script from "./DataManagement.vue?vue&type=script&lang=js&"
export * from "./DataManagement.vue?vue&type=script&lang=js&"
import style0 from "./DataManagement.vue?vue&type=style&index=0&id=2ceac6b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceac6b2",
  null
  
)

export default component.exports